<template>
  <div
    style="padding: 15px"
    class="bg-white"
    label-position="top"
    v-loading.fullscreen.locking="isLoading"
  >
    <h4 class="form-title">Stock Out Information</h4>
    <el-form ref="stockForm" :model="stockout" :rules="rules">
      <el-row :gutter="15">
        <el-col :sm="12">
          <el-form-item label="Job Order No." prop="job_order_no">
            <el-input
              v-if="is_readonly"
              :readonly="true"
              v-model="stockout.job_order_no"
            ></el-input>
            <el-select
              v-if="!is_readonly"
              v-model="stockout.job_order_no"
              filterable
              clearable
              @change="getRequests"
            >
              <el-option
                v-for="jo in jo_list"
                :key="jo.id"
                :value="jo.id"
                :label="jo.job_order_number"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- <el-col :sm="12">
          <el-form-item label="Date" prop="date">
            <el-date-picker v-model="stockout.date"></el-date-picker>
          </el-form-item>
        </el-col> -->
      </el-row>
      <h4 class="form-title">Parts</h4>
      <el-table :data="stockout.items" v-loading="isTableLoading">
        <el-table-column width="100px" label="Actions" v-if="false">
          <template slot-scope="scope">
            <el-button
              v-if="false"
              @click="removePart(scope.row)"
              type="danger"
              icon="el-icon-close"
              size="small"
              circle
              title="Remove"
            ></el-button>
            <el-button
              v-if="false"
              @click="editPart(scope.row)"
              type="primary"
              icon="el-icon-edit"
              size="small"
              circle
              title="Edit"
            ></el-button>
          </template>
        </el-table-column>

        <el-table-column label="Part No." prop="part_no">
          <template slot-scope="scope">
            <a :href="'/parts/info/' + scope.row.part_id" target="_blank">{{
              scope.row.part_no
            }}</a>
          </template>
        </el-table-column>
        <el-table-column
          label="Description"
          prop="part_description"
        ></el-table-column>
        <el-table-column
          label="Location"
          prop="part_location"
        ></el-table-column>
        <el-table-column label="Batch No." prop="batch_no" v-if="is_readonly">
        </el-table-column>
        <el-table-column label="Current Stock Qty." prop="remaining_qty">
        </el-table-column>
        <el-table-column width="180" label="Order Quantity" prop="quantity">
          <template slot-scope="scope">
            <el-input-number
              v-model.number="scope.row.quantity"
              :controls="false"
              @change="handleQuantityChange(scope.row)"
              v-if="scope.row.edit"
            ></el-input-number>
            <span v-else>{{ scope.row.quantity | number("0,0") }}</span>
          </template>
        </el-table-column>
        <el-table-column width="180" label="Date" prop="date_issued">
          <template slot-scope="scope">
            <el-date-picker
              v-model="scope.row.date_issued"
              v-if="scope.row.edit"
            ></el-date-picker>
            <span v-else>{{ scope.row.date_issued | dateFormat }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="mt-2">
        <el-button
          type="primary"
          size="small"
          @click="submitStockout"
          :disabled="isLoading"
          v-if="!is_readonly"
          >Submit for Supervisor Approval</el-button
        >
        <el-button
          type="primary"
          size="small"
          @click="addPart = true"
          :disabled="isLoading"
          v-if="false"
          >Add Part</el-button
        >
        <el-button size="small" @click="cancel">Cancel</el-button>
      </div>
    </el-form>
    <el-dialog
      :visible.sync="addPart"
      @opened="initAddForm"
      @close="clearForm"
      :close-on-click-modal="false"
    >
      <el-form ref="addPartForm" :model="addForm" :rules="addForm.rules">
        <el-form-item label="Input/Scan part number" prop="part_no">
          <!-- <el-input
            id="part_no"
            :autofocus="true"
            v-model="addForm.part_no"
            @blur="getPartInfo"
          ></el-input> -->
          <el-select
            id="part_no"
            v-model="addForm.part_no"
            filterable
            @change="getPartInfo"
          >
            <el-option
              v-for="part in parts"
              :key="part.id"
              :value="part.part_no"
              :label="part.part_no"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Part Description" prop="_part.description">
          <el-input
            :readonly="true"
            v-model="addForm._part.description"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="mt-2 text-right">
        <el-button
          type="primary"
          size="small"
          @click="usePart"
          :disabled="isTableLoading"
          ><i v-if="isTableLoading" class="el-icon-loading mr-1"></i
          >Add</el-button
        >
        <el-button
          :disabled="isTableLoading"
          size="small"
          @click="addPart = false"
          >Cancel</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import Part from "@/models/Part";
import ULD from "@/models/ULD";
export default {
  name: "StockoutInfo",
  computed: {
    parts() {
      return this.$store.getters["part/glossary"];
    },
    is_readonly() {
      if (this.$route.params.id || this.stockout.id) return true;
      return false;
    }
  },
  data() {
    return {
      isLoading: false,
      addPart: false,
      isTableLoading: false,
      addForm: {
        _part: {},
        part_no: "",
        rules: {
          part_no: [
            { required: true, message: "Part Number is required." },
            {
              validator: (rule, value, callback) => {
                var part = this.parts.find(o => {
                  return o.part_no == value;
                });

                if (!part) {
                  return callback(new Error("Part information not found."));
                }

                this.addForm.part_id = part.id;
                part = this.stockout.items.find(o => {
                  return o.part_no == value;
                });

                if (part) {
                  return callback(new Error("This part is already added."));
                }

                callback();
              },
              trigger: "blur"
            }
          ]
        }
      },
      stockout: {
        job_order_no: "",
        date: moment(),
        items: []
      },
      rules: {
        jo_id: [{ required: true, message: "Job Order No. is required." }]
        // date: [{ required: true, message: "Date is required." }]
      },
      jo_list: []
    };
  },
  mounted() {
    this.$store.dispatch("part/getGlossary");
    if (this.$route.params && this.$route.params.id) {
      this.fetch();
    }
    this.library();
  },
  methods: {
    fetch() {
      this.stockout = {
        job_order_no: "",
        date: moment(),
        items: []
      };
      this.isLoading = true;
      Part.stockout(this.$route.params.id).then(resp => {
        if (resp) {
          this.isLoading = false;
          let so = resp;
          // let promises = [];
          for (let item of so.items) {
            item._default = { ...item };
            item.edit = false;
            item.part_location = item.location;
            item.part_description = item.description;
            item.remaining_qty = item.current_quantity.total;
            // promises.push(
            //   Part.fetch(item.part_id).then(partInfo => {
            //     if (partInfo) {
            //       item._part = partInfo;
            //       item.part_description = partInfo.description;
            //       item.part_location = partInfo.location;
            //     }
            //   })
            // );
            // promises.push(
            //   Part.getStocks(item.part_id).then(resp => {
            //     if ("total" in resp && resp.total) {
            //       item.remaining_qty = resp.total;
            //     }
            //   })
            // );
          }
          // Promise.all(promises).then(() => {
          this.stockout = so;
          //   this.isLoading = false;
          // });
        }
      });
    },
    cancel() {
      return this.$router.push({
        name: "stockout"
      });
    },
    initAddForm() {
      document.getElementById("part_no").focus();
      this.$refs.addPartForm.clearValidate();
      this.addForm.part_no = "";
      this.addForm._part = {};
    },
    clearForm() {},
    usePart() {
      this.$refs.addPartForm.validate(valid => {
        if (!valid) return false;
        // get remaining quantity from backend
        // insert to items
        // this.addPart = false;
        this.isTableLoading = true;
        Part.getStocks(this.addForm._part.id).then(resp => {
          if ("total" in resp && resp.total) {
            var remaining_qty = resp.total;
            Part.fetch(this.addForm._part.id).then(resp => {
              var part = new Part(resp);
              this.stockout.items.push({
                _part: part,
                part_no: part.part_no,
                part_id: part.id,
                part_description: part.description,
                part_location: part.location,
                remaining_qty: remaining_qty,
                quantity: 0,
                date_issued: moment().format("YYYY-MM-DD"),
                edit: true
              });
              this.addPart = false;
              this.isTableLoading = false;
            });
          } else {
            this.$notify({
              type: "error",
              message: "No stocks available.",
              position: "bottom-right"
            });
            this.isTableLoading = false;
          }
        });
      });
    },
    getPartInfo() {
      var part = this.parts.find(o => {
        return o.part_no == this.addForm.part_no;
      });
      if (part) {
        this.addForm._part = { ...part };
      }
      // if (this.addForm.part_no) {
      //   Part.fetch(this.addForm.part_id).then(resp => {
      //     if (resp) {
      //       var part = new Part(resp);
      //     }
      //   });
    },
    handleQuantityChange(order) {
      if (order.quantity > order.remaining_qty) {
        order.quantity = order.remaining_qty;
      }
    },
    submitStockout() {
      this.$confirm(
        "Are you sure you want to save this stock out information?",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No"
        }
      )
        .then(() => {
          this.$refs.stockForm.validate(valid => {
            if (!valid) return false;

            if (this.stockout.items.length <= 0) {
              this.$notify({
                type: "error",
                message: "Please add at least one Part.",
                position: "bottom-right"
              });
              return false;
            }

            var maxCheck = this.stockout.items.find(o => {
              return o.quantity > 200;
            });
            if (maxCheck) {
              this.$notify({
                type: "error",
                message: "Maximum stockout quantity is 200 only.",
                position: "bottom-right"
              });
              return false;
            }

            var zeroCheck = this.stockout.items.find(o => {
              return o.quantity == 0;
            });
            if (zeroCheck) {
              this.$notify({
                type: "error",
                message: "Order quantities should be more than 1.",
                position: "bottom-right"
              });
              return false;
            }

            if (this.stockout.id) {
              // update
              let stockout = {
                job_order_no: this.stockout.job_order_no,
                id: this.stockout.id,
                items: []
              };

              for (let item of this.stockout.items) {
                stockout.items.push({
                  date_issued: item.date_issued,
                  part_id: item.part_id,
                  location: item.part_location,
                  quantity: item.quantity,
                  old_quantity: item._default.quantity,
                  add_qty:
                    item.quantity < item._default.quantity
                      ? item._default.quantity - item.quantity
                      : 0
                });
              }

              this.isLoading = true;
              // console.log(JSON.stringify(stockout));
              Part.updateStocks(stockout).then(resp => {
                if (resp) {
                  this.isLoading = false;
                  this.fetch();
                  this.$notify({
                    type: "success",
                    message: "Stockout information saved successfully.",
                    position: "bottom-right"
                  });
                }
                // console.log(resp);
              });
            } else {
              // create
              let stockout = {
                job_order_no: this.stockout.job_order_no,
                items: []
              };
              for (let item of this.stockout.items) {
                stockout.items.push({
                  date_issued: item.date_issued,
                  part_id: item.part_id,
                  location: item.part_location,
                  quantity: item.quantity
                });
              }
              this.isLoading = true;
              Part.consumeStocks(stockout).then(resp => {
                this.isLoading = false;
                if (resp && resp.code == 200) {
                  this.$notify({
                    type: "success",
                    message: "Stockout information saved successfully.",
                    position: "bottom-right"
                  });
                  this.$router.push({ name: "stockout" });
                }
              });
            }
          });
        })
        .catch(() => {});
    },
    removePart(part) {
      this.$confirm(
        "Are you sure you want to remove this Part from the Job Order?",
        {
          confirmButtonText: "Yes"
        }
      )
        .then(() => {
          this.stockout.items = this.stockout.items.filter(
            o => o.id != part.id
          );
        })
        .catch(() => {});
    },
    editPart(part) {
      part.edit = true;
    },
    library() {
      this.jo_list = [];
      ULD.jo_list().then(list => {
        this.jo_list = list;
      });
    },
    getRequests() {
      this.stockout.items = [];
      let jo_id = this.stockout.job_order_no;
      if (!jo_id) {
        return false;
      }
      // this.stockout.job_order_no = this.jo_list.find(
      //   o => o.id == jo_id
      // ).job_order_number;
      this.isLoading = true;
      ULD.get_requested_parts({
        uldin_id: jo_id,
        status: 1,
        limit: 99999
      }).then(list => {
        this.isLoading = false;
        if (list) {
          for (let item of list.data) {
            Part.getStocks(item.requested_parts.id).then(resp => {
              if ("total" in resp && resp.total) {
                let part = {
                  _default: item,
                  // date_issued: item.date_issued,
                  part_id: item.requested_parts.id,
                  part_no: item.requested_parts.part_no,
                  part_description: item.requested_parts.description,
                  part_location: item.requested_parts.location,
                  quantity: item.quantity,
                  remaining_qty: resp.total,
                  _id: Date.now(),
                  date_issued: moment().format("YYYY-MM-DD")
                };
                this.stockout.items.push(part);
              }
            });
          }
        }
      });
    }
  }
};
</script>

<style lang="css" scoped></style>
